import { createAction } from '@reduxjs/toolkit'

export enum Field {
  CURRENCY_A = 'CURRENCY_A',
  CURRENCY_B = 'CURRENCY_B',
}

export enum Bound {
  LOWER = 'LOWER',
  UPPER = 'UPPER',
}

export const typeInput = createAction<{ field: Field; typedValue: string; noLiquidity: boolean }>(
  'mintIsland/typeInputMint'
)
export const setSingleSided = createAction<{ singleSided: boolean; singleSidedCurrency: string }>(
  'mintIsland/setSingleSided'
)

export const setSingleSidedAmount = createAction<{ singleSidedAmount: string }>('mintIsland/setSingleSidedAmount')
export const setSingleSidedCurrency = createAction<{ singleSidedCurrency: string }>('mintIsland/setSingleSidedCurrency')
export const resetMintState = createAction<void>('mintIsland/resetMintState')
export const setZapSwapSlippage = createAction<{ zapSwapSlippage: string }>('mintIsland/setZapSwapSlippage')
export const setStakingSlippageBPS = createAction<{ stakingSlippageBPS: number }>('mintIsland/setStakingSlippageBPS')
export const resetSingleSidedValues = createAction<void>('mintIsland/resetSingleSidedValues')
export const switchFields = createAction<{
  independentField: Field
  typedValue: string
  otherTypedValue: string
}>('mintIsland/switchFields')
